<div class="card">
  <h2>{{title}}</h2>
  <p>{{text}}</p>

  @if (optional) {
  <p>{{optional}}</p>
  }
</div>
